<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Shane Offerman lives in Ottawa, Ontario with his wife Donna. He has three adult kids, Emily, Jacob, and Meghan. When Shane takes a break from writing, he’s outdoors cooking on the grill, nurturing his small, English garden, or building wood furniture. Shane is also a certified black belt in Tae Kwon Do.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?15e03bdf